import { ABodyColor, ABodySize } from '../../atoms/ABody/ABody.types';
import { AEyebrowVariant } from '../../atoms/AEyebrow/AEyebrow.types';
import { AHeaderSize, AHeaderTag } from '../../atoms/AHeader/AHeader.types';

export enum MTextBlockSimpleAlignment {
  Left = 'Left',
  Center = 'Center',
}

export interface MTextBlockSimpleProps {
  alignment?: MTextBlockSimpleAlignment;
  eyebrowText?: string;
  eyebrowVariant?: AEyebrowVariant;
  headerText?: string;
  headerSize?: AHeaderSize;
  headerTag?: AHeaderTag;
  bodyText?: string;
  bodySize?: ABodySize;
  bodyColor?: ABodyColor;
  aBody?: {
    className?: string;
  };
}
